module.exports = __webpack_public_path__ + "static/media/add_translation.2e675163.png";